import { render, staticRenderFns } from "./productSet.vue?vue&type=template&id=3e547dcb&"
import script from "./productSet.vue?vue&type=script&lang=js&"
export * from "./productSet.vue?vue&type=script&lang=js&"
import style0 from "./productSet.vue?vue&type=style&index=0&id=3e547dcb&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports